import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, isRef as _isRef, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-dac864c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]

import {ref} from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ImageOverlay',
  props: {
    name: {},
    file: {}
  },
  setup(__props: any) {

const props = __props
let image = ref(false)


return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("span", null, [
    _createVNode(_component_v_dialog, {
      modelValue: _unref(image),
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(image) ? (image).value = $event : image = $event)),
      width: "500",
      scrollable: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { color: "modal" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "image-name" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  class: "image",
                  src: require(`@/assets/v2/${_ctx.file}`),
                  alt: ""
                }, null, 8, _hoisted_1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_divider, { class: "blue-grey darken-3" }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  text: "",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_isRef(image) //@ts-ignore
 ? image.value = false : image = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('V2.close')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("span", {
      class: "image-link",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_isRef(image) //@ts-ignore
 ? image.value = true : image = true))
    }, [
      _createVNode(_component_v_icon, null, {
        default: _withCtx(() => [
          _createTextVNode("image")
        ]),
        _: 1
      }),
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})